// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="use-the-va-facilities-api-to-find-information-about-a-specific-va-facility.">Use the VA Facilities API to find information about a specific VA facility.</h2>
      <p>This API uses open data to return contact information, location, hours of operation and available services for VA facilities. For medical facilities only, we provide data on appointment wait times and patient satisfaction. <Link to="/release-notes/facilities">Review the latest release notes</Link>.</p>
    </div>
  );
};

export default MarkdownComponent;
